/**
 * A list of product sorting options.
 * @type {Array<{id: string, name: string}>}
 * @property {string} id - The filter id.
 * @property {string} name - The i18n key for the sorting option name.
 */
export const PRODUCT_SORTING_LIST = [
  { id: "priority-descending", name: "custom.products_overview.sorting_relevance" },
  { id: "name-ascending", name: "custom.products_overview.sorting_alphabet_a_z" },
  { id: "name-descending", name: "custom.products_overview.sorting_alphabet_z_a" },
  { id: "price-ascending", name: "custom.products_overview.sorting_price_ascending" },
  { id: "price-descending", name: "custom.products_overview.sorting_price_descending" },
];
